import DashNav3 from "../components/DashNav3";
import InvoiceList from "../components/InvoiceList";
import {Link} from 'react-router-dom'
import { useInvoiceContext } from "../hooks/useInvoiceContext";
import {useState} from 'react';

const NewInvoices = () => {
    const {invoices} = useInvoiceContext();
    const [searchTerm, setSearchTerm] = useState('');

    return ( 
        
        <div className="newclientscontainer">
        <DashNav3></DashNav3>
        <div className="newclientsright">
            <div className="newclientstop">
            <h1 className="text-3xl font-bold">Invoices</h1>
            <Link to="/createinvoice">
            <button className="btn btn-primary" id="newclientsbutton">New Invoice</button>
            </Link>
            </div>
            <hr id="newline1"/>
            <div className="clientsdata">
                <div className="clientsdatadiv">
                <h1 className="text-2xl text-black" >All Invoices</h1>
                <div className="clientscount2">
                {invoices ? <h1 className="text-md text-black font-bold">{invoices.length}</h1> : <h1 className="text-md text-black font-bold">0</h1>}
                </div>
                </div>

        <div className="join">
                <div>
                <div>
                <input className="input input-bordered join-item" placeholder="Search" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)}/>
                </div>
                </div>
                <div className="indicator">
                <button className="btn join-item">Search</button>
                </div>
            </div>
            </div>
            <InvoiceList searchTerm={searchTerm}></InvoiceList>
        </div>
    </div>
     );
}
 
export default NewInvoices;